<template>
  <div class="container">
    <div class="sub-page">
      <cube-textarea :maxlength="200" v-model="value" placeholder="请输入反馈建议..."></cube-textarea>
      <button @click="submit" style="margin-top: 15px;" class="my-btn">提交</button>
    </div>
  </div>
</template>

<script>
import { saveComplaininfo } from "@/api/bapi";
import { constants } from "fs";
export default {
  name: "Feedback",
  data() {
    return {
      value: "",
      userInfo: {}
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Feedback/gi.test(to.path)) {
        this.getInfo();
      }
    }
  },
  computed: {
    httpUrl() {
      return this.$store.state.httpUrl;
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const userInfoData = localStorage.getItem("loginUserInfo");
      if(!userInfoData)
      {
        this.errorShow("未登录，或登录已经过期，请重新登录！");
        setTimeout(() => {
          this.$router.push({name:'Login'})
        },2000)
        return;
      }
      this.userInfo = JSON.parse(userInfoData);
      console.log(this.userInfo)
      this.value = "";
      console.log(this.userInfo);
    },
    errorShow(msg) {
      this.$Message.error(msg);
      setTimeout(() => {
        this.addMd = false;
        this.$nextTick(() => {
          this.addMd = true;
        });
      }, 100);
    },
    submit() {
      if (!this.value || this.value == "") {
        this.errorShow("请输入您要反馈的内容");
      } else {
        let data = {
          areaId: "431027",
          sysSource: "05",
          username: this.userInfo.sysUser.username,
          mobile: this.userInfo.sysUser.phone
            ? this.userInfo.sysUser.phone
            : "",
          companyName: "真源码研发中心",
          productName: "系统反馈",
          content: this.value,
          code: "",
          randomStr: "",
          ipAddress: ""
        };
        saveComplaininfo(data).then(res => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              this.$Message.success("反馈成功");
              this.value='';
            } else {
              this.errorShow(res.data.msg);
            }
          }
        })
      }
    }
  }
};
</script>

<style scoped>
.photo {
  width: 30%;
}
.photo img {
  width: 100%;
}
h3 {
  font-size: 1.4rem;
  font-weight: bold;
  margin-top: 5px;
}
.list {
  width: 100%;
  margin: 20px auto 0;
  text-align: left;
}
.list li {
  padding: 20px;
  background-color: white;
  border-bottom: 1px solid rgb(222, 221, 221);
}
.ic {
  float: right;
}
.bt {
  width: 40%;
  margin: 0px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 6px;
  text-align: center;
  font-size: 0.8rem;
  color: white;
  background-color: #fc9153;
}
.my-btn {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Feedback.vue